import { ReactNode } from 'react';
import { KanfyLogo } from '@/components/KanfyLogo';

interface LoadingSpinnerProps {
  message?: string;
}

/**
 * Full-screen wait shown while auth and route guards resolve. Calm on
 * purpose: the logo and one slim indeterminate bar, instead of the old
 * spinner + pulse + bouncing dots, which made every signed-in page open
 * with a busy flourish.
 */
export const LoadingSpinner = ({ message = "Loading..." }: LoadingSpinnerProps): ReactNode => (
  <div className="min-h-dvh flex items-center justify-center bg-background px-6" role="status" aria-live="polite">
    <div className="flex flex-col items-center gap-5">
      <KanfyLogo variant="auto" size="lg" showWordmark={false} />
      <div className="h-1 w-32 overflow-hidden rounded-full bg-muted" aria-hidden="true">
        <div className="h-full w-2/5 rounded-full bg-success animate-loader-slide" />
      </div>
      <p className="text-sm font-medium text-muted-foreground">{message}</p>
    </div>
  </div>
);

export default LoadingSpinner;
